import './index.scss';
import classnames from 'classnames';
import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import ClassificationResultsFilter from '~/components/classification_results_filter';
import ResponsiveItem from '~/components/responsive_item';
import prepareClassificationMap from '~/utils/prepareClassificationMap';
import prepareComparisonDocs from '~/utils/prepareComparisonDocs';
import ClauseItem from './clause_item';
const LeftPanel = ({ state }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedDescriptors, setSelectedDescriptors] = useState([]);
    const [panelCollapsed, setPanelCollapsed] = useState(false);
    const { accordionRef, activeClauseIds, anchorDoc, anchorHasRendered, comparatorDoc, comparatorHasRendered, comparisonDocuments, selectedClauseName, setActiveClauseIds, setSelectedClauseName, } = state;
    if (!comparisonDocuments.length ||
        !(anchorDoc === null || anchorDoc === void 0 ? void 0 : anchorDoc.classifications) ||
        !(comparatorDoc === null || comparatorDoc === void 0 ? void 0 : comparatorDoc.classifications))
        return React.createElement("div", null);
    const { documents, categories, descriptors } = prepareComparisonDocs(anchorDoc.documentComparisonFileId, [anchorDoc, comparatorDoc]);
    let classificationMap;
    if (documents.length > 1) {
        classificationMap = prepareClassificationMap(documents[0], documents[1], selectedCategories, selectedDescriptors);
    }
    const panelClass = classnames('left-panel', {
        collapsed: panelCollapsed,
    });
    const hideClass = classnames('fas', {
        'fa-chevron-left': !panelCollapsed,
        'fa-chevron-right': panelCollapsed,
    });
    const renderClauseItems = () => {
        const items = [];
        for (const [name, classification] of classificationMap) {
            items.push(React.createElement(ClauseItem, { key: name, accordionRef: accordionRef, activeClauseIds: activeClauseIds, anchorClauses: classification.anchorClauses, classificationName: name, comparatorClauses: classification.comparatorClauses, documents: documents, selectedName: selectedClauseName, setSelectedName: setSelectedClauseName, setActiveClauseIds: setActiveClauseIds }));
        }
        return items;
    };
    return (React.createElement("div", { className: panelClass },
        (!anchorHasRendered || !comparatorHasRendered) && React.createElement("div", { className: 'panel-overlay' }),
        React.createElement("div", { title: `${panelCollapsed ? 'Expand Panel' : 'Collapse Panel'}`, className: 'hide-icon', onClick: () => setPanelCollapsed(!panelCollapsed) },
            React.createElement("span", null,
                React.createElement("i", { className: hideClass }))),
        React.createElement("div", { className: 'left-panel-header' },
            React.createElement("h4", null, "PDF Navigation"),
            React.createElement("div", { className: 'classification-filter-container' },
                React.createElement(ClassificationResultsFilter, { categories: categories, selectedCategories: selectedCategories, setSelectedCategories: setSelectedCategories, descriptors: descriptors, selectedDescriptors: selectedDescriptors, setSelectedDescriptors: setSelectedDescriptors }),
                React.createElement(ResponsiveItem, { overflowText: 'Classifications', wrapperClassName: 'classification-filter' }, "Classifications"))),
        React.createElement("div", { className: 'clause-items' },
            React.createElement("div", { className: 'accordion-wrapper' },
                React.createElement(Accordion, { className: 'clause-accordion' }, renderClauseItems())))));
};
export default LeftPanel;
